module.exports = __webpack_public_path__ + "static/29-9046ee4cc577e5a17e7adb32918b88bc.jpg";